import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES } from '../i18n';

function GlobeIcon() {
  return (
    <svg
      className="language-switcher-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  );
}

export default function LanguageSwitcher({ className }) {
  const { t, i18n } = useTranslation();
  const current = SUPPORTED_LOCALES.find((l) => l.code === i18n.language)?.code ?? 'en';
  const wrapperClass = className === 'navbar-mobile-language'
    ? 'language-switcher-wrap navbar-mobile-language-wrap'
    : 'language-switcher-wrap';

  return (
    <div className={wrapperClass}>
      <GlobeIcon />
      <select
        className={className || 'language-switcher'}
        value={current}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        aria-label={t('language.selectLanguage')}
      >
        {SUPPORTED_LOCALES.map((locale) => (
          <option key={locale.code} value={locale.code}>
            {locale.nativeLabel}
          </option>
        ))}
      </select>
    </div>
  );
}
